// extracted by mini-css-extract-plugin
module.exports = {"playerselectorModal":"_2qlnw9M","gameModalFit":"_3dQSYaF","flexFull":"_1vEExqK","desktopEmbedded":"_1KbU2Ek","flexFullFit":"_qh_E7lU"};